import Vue from 'vue'
import VueRouter from 'vue-router'
import login from '../views/login'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'login',
    component: login
  },
  {
    path: '/main',
    name: 'main',
    component: () => import('../views/main')
  },
  {
    path: '/reg',
    name: 'reg',
    component: () => import('../views/reg')
  },
  {
    path: '/info',
    name: 'info',
    component: () => import('../views/info')
  },
  {
    path: '/add',
    name: 'add',
    component: () => import('../views/add/')
  },
  {
    path: '/view',
    name: 'view',
    component: () => import('../views/view/')
  },
  // 学生个人作品页面
  {
    path: '/my-works',
    name: 'myWorks',
    component: () => import('../views/myWorks/')
  },
  {
    path: '/my-add',
    name: 'myAdd',
    component: () => import('../views/myWorks/add')
  }
]

const router = new VueRouter({
  routes
})

export default router
